import React, { useCallback } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Modal from "modules/Modal/Modal";
import DailyInspectionForm from "./DailyInspectionForm";
import useGetDailyFormInspection from "hooks/fleet/useGetDailyFormInspection";
import useUpdateDailyFormInspection from "hooks/fleet/useUpdateDailyFormInspection";
import { UpdateDailyFormInspectionInput } from "generated/graphql";

interface EditDailyInspectionModalProps {
  open: boolean;
  onClose: () => void;
  inspectionId: string;
}

export default function EditDailyInspectionModal({
  open,
  onClose,
  inspectionId,
}: EditDailyInspectionModalProps) {
  const { data: inspection, loading: loadingInspection } = useGetDailyFormInspection({
    id: inspectionId,
  });
  const [updateInspection, { loading: updating }] = useUpdateDailyFormInspection();

  const handleFormSubmit = useCallback(
    async (data: UpdateDailyFormInspectionInput) => {
      const submitData: UpdateDailyFormInspectionInput = {
        ...data,
        id: inspectionId,
      };

      const result = await updateInspection({
        variables: {
          input: submitData,
        },
      });

      if (result.data?.updateDailyFormInspection) {
        onClose();
      }
    },
    [inspectionId, updateInspection, onClose]
  );

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  const modalStyles = {
    height: "auto",
    maxHeight: "90vh",
    width: "90vw",
    maxWidth: "800px",
    overflow: "auto",
  };

  return (
    <Modal open={open} onClose={onClose} styles={modalStyles}>
      <MDBox p={3}>
        <MDTypography variant="h5" fontWeight="medium" mb={3}>
          Edit Daily Inspection
        </MDTypography>

        {loadingInspection ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="400px">
            <MDTypography variant="body2">Loading inspection...</MDTypography>
          </MDBox>
        ) : (
          <DailyInspectionForm
            type="edit"
            onSubmit={handleFormSubmit}
            onCancel={handleCancel}
            loading={updating}
            inspection={inspection}
          />
        )}
      </MDBox>
    </Modal>
  );
}
